/** @jsx jsx */

import { ReactNode } from 'react';

import { Icon } from '@zapier/design-system';
import { jsx } from '@emotion/core';
import { Colors, Spacing } from '@zapier/theme';
import {
  createKeyHandler,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

const Styles = labelStyles(__filename, {
  root: isSmall => [
    isSmall &&
      withModifier('small', {
        display: 'flex',
        justifyContent: 'space-between',
        padding: Spacing.small,
        gridTemplateColumns: '90% 10%',
        ':hover, :focus': {
          backgroundColor: Colors.storm,
          '#drilldown-list-item-arrow': {
            transform: 'translateX(5px)',
          },
        },
      }),
    !isSmall &&
      withModifier('large', {
        display: 'grid',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        padding: Spacing.medium,
        gridTemplateColumns: '85% 15%',
        ':hover, :focus': {
          backgroundColor: Colors.storm,
          '#drilldown-list-item-arrow': {
            transform: 'translateX(15px)',
          },
        },
      }),
  ],
  arrow: isSmall => [
    isSmall &&
      withModifier('small', {
        display: 'flex',
        alignSelf: 'baseline',
        justifyContent: 'flex-end',
        transition: 'transform 150ms ease-in-out',
      }),
    !isSmall &&
      withModifier('large', {
        width: '50%',
        transition: 'transform 150ms ease-in-out',
        display: 'grid',
      }),
  ],
});

type Props = {
  children: ReactNode | Array<ReactNode>;
  onClick: () => void;
  isSmall: boolean;
};

const DrillDownListItem = (props: Props) => {
  const iconSize = (props.isSmall && 20) || (!props.isSmall && 30);

  return (
    <div
      css={Styles.root(props.isSmall)}
      onClick={props.onClick}
      onKeyDown={createKeyHandler(['enter', 'space'], props.onClick)}
      role="button"
      tabIndex={0}
    >
      <main>{props.children}</main>
      <span css={Styles.arrow(props.isSmall)} id="drilldown-list-item-arrow">
        <Icon color="GrayWarm7" name="arrowSmallRight" size={iconSize} />
      </span>
    </div>
  );
};

DrillDownListItem.defaultProps = {
  isSmall: false,
};

export default DrillDownListItem;
